import { render, staticRenderFns } from "./bookinged.vue?vue&type=template&id=2206b392&scoped=true&"
import script from "./bookinged.vue?vue&type=script&lang=js&"
export * from "./bookinged.vue?vue&type=script&lang=js&"
import style0 from "./bookinged.vue?vue&type=style&index=0&id=2206b392&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206b392",
  null
  
)

export default component.exports